"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Radio = require("./Radio.style");

var _class;

var Radio = (0, _emotionTheming.withTheme)(_class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Radio, _PureComponent);

  function Radio() {
    (0, _classCallCheck2.default)(this, Radio);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Radio).apply(this, arguments));
  }

  (0, _createClass2.default)(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          label = _this$props.label,
          style = _this$props.style,
          className = _this$props.className,
          themeType = _this$props.themeType,
          showDarkBackground = _this$props.showDarkBackground,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "label", "style", "className", "themeType", "showDarkBackground"]);
      var labelWithTheme = themeType === 'light' ? _Radio.labelStyles : _Radio.labelStylesDark;
      var radioboxWithTheme = themeType === 'light' ? _Radio.radioboxStyles : _Radio.radioboxStylesDark;
      var radioCircleWithTheme = themeType === 'light' ? _Radio.radioInnerCircle : _Radio.radioInnerCircleDark;
      return _react.default.createElement("label", {
        style: style,
        className: (0, _classnames.default)(className, labelWithTheme(theme, showDarkBackground))
      }, _react.default.createElement("input", (0, _extends2.default)({
        type: "radio"
      }, other)), _react.default.createElement("div", {
        className: radioboxWithTheme(theme)
      }, _react.default.createElement("span", {
        className: radioCircleWithTheme(theme)
      })), _react.default.createElement("span", null, label));
    }
  }]);
  return Radio;
}(_react.PureComponent)) || _class;

Radio.propTypes = {
  label: _propTypes.default.string,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  themeType: _propTypes.default.string,
  showDarkBackground: _propTypes.default.bool
};
Radio.defaultProps = {
  label: '',
  style: {},
  className: '',
  themeType: 'light',
  showDarkBackground: false
};
var _default = Radio;
exports.default = _default;